import SectionHead from "./SectionHead";
import { recommended } from "@/mocks/cgua";

export default function Recommended() {
  return (
    <section id="tuijian" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          no="06"
          eyebrow="17吃瓜推荐"
          title="编辑推荐 · 盲点也替你挖到"
          desc="不重复你已在热榜刷到的，专挑时间线、幕后与数据角度，帮你把瓜吃出层次。"
          linkLabel="今日全部推荐"
        />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {recommended.map((r, i) => (
            <article
              key={r.title}
              className={
                "group rounded-xl border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors flex flex-col " +
                (i % 6 === 0 ? "md:col-span-2 lg:col-span-1" : "")
              }
            >
              <div className="relative overflow-hidden">
                <div className="w-full h-[150px] md:h-[170px]">
                  <img
                    src={r.cover}
                    alt={`${r.title} 推荐配图`}
                    title={`17吃瓜推荐 · ${r.title}`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.06]"
                  />
                </div>
                <span className="absolute top-2.5 left-2.5 inline-flex items-center gap-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1">
                  <i className="ri-star-smile-fill text-[12px]" />
                  {r.reason}
                </span>
              </div>
              <div className="p-3.5 md:p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {r.title}
                </h3>
                <div className="mt-2.5 flex items-center justify-between border-t border-background-100 pt-2.5">
                  <span className="text-xs text-foreground-500">{r.meta}</span>
                  <a
                    href="#"
                    aria-label={`查看推荐：${r.title}`}
                    className="inline-flex items-center justify-center w-7 h-7 rounded-full text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-up-line text-[14px]" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}